import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=cb81b1bc&"
import script from "./ButtonList.vue?vue&type=script&lang=ts&"
export * from "./ButtonList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports